// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"data-error"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3H21V12H3V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 12H3M21 12V13.5M21 12V3H3V12M3 12L3 21.0004H13.5M3 12V11.998M6.99805 16.5H7.00195V16.5039H6.99805V16.5ZM6.99805 7.5H7.00195V7.50391H6.99805V7.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21.6215 17.3789L19.5002 19.5002M19.5002 19.5002L17.3789 21.6215M19.5002 19.5002L17.3789 17.3789M19.5002 19.5002L21.6215 21.6215","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-data-error')
export default class DataErrorIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'data-error',
    }
  }
}
